import { render, staticRenderFns } from "./FacialCashierDetail.vue?vue&type=template&id=60e572b2&scoped=true"
import script from "./FacialCashierDetail.vue?vue&type=script&lang=js"
export * from "./FacialCashierDetail.vue?vue&type=script&lang=js"
import style0 from "./FacialCashierDetail.vue?vue&type=style&index=0&id=60e572b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e572b2",
  null
  
)

export default component.exports